import { useContent } from '@/lib/ContentContext'
import { Nav } from '@/sections/Nav'
import { Hero } from '@/sections/Hero'
import { Technology } from '@/sections/Technology'
import { Hub } from '@/sections/Hub'
import { Vfx } from '@/sections/Vfx'
import { Studio } from '@/sections/Studio'
import { Contact } from '@/sections/Contact'
import { Footer } from '@/sections/Footer'
import { useSectionTracking } from '@/lib/analytics/useSectionTracking'

export default function Landing() {
  const { content } = useContent()
  useSectionTracking()

  return (
    // ⚠️ 이 래퍼에 overflow-hidden을 걸면 안 된다.
    // overflow:hidden 인 조상은 새 스크롤 컨테이너를 만들어 sticky nav를 깨뜨린다.
    // 넘치는 장식(Hero 글로우, Contact 글로우)은 각 섹션에서 직접 클리핑한다.
    <div className="bg-surface-base">
      <Nav data={content.nav} />
      <Hero data={content.hero} theme={content.theme} />
      <Technology data={content.technology} />
      {/* 섹션 순서: Hub(B2B) → Studio(B2C) → VFX */}
      <Hub data={content.hub} />
      <Studio data={content.studio} />
      <Vfx data={content.vfx} />
      <Contact data={content.contact} />
      <Footer data={content.footer} />
    </div>
  )
}
